import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App/index.js';
import { LangProvider } from './TodoContext/langContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LangProvider>
        <App />
    </LangProvider>
);


window.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
        document.querySelector('.TodoForm-button--add').click();
    } else if (e.key === 'Escape') {
        document.querySelector('.TodoForm-button--cancel').click();
    } else if (e.key === 'c' && document.getElementById('modal').childElementCount === 0) {
        document.querySelector('.CreateTodoButton').click();
        setTimeout(() => {
            document.getElementsByTagName("textarea")[0].focus();    
        }, 100);
        
    }
}, false);